import { render, staticRenderFns } from "./CrmNotificationSettings.vue?vue&type=template&id=7b456320&scoped=true"
import script from "./CrmNotificationSettings.vue?vue&type=script&lang=js"
export * from "./CrmNotificationSettings.vue?vue&type=script&lang=js"
import style0 from "./CrmNotificationSettings.vue?vue&type=style&index=0&id=7b456320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b456320",
  null
  
)

export default component.exports